export enum TranslationSource {
    SERVERLESS_TEXT_TRANSLATOR = 'serverless-text-translator',
    SERVERLESS_AI_TEXT_GENERATOR = 'serverless-ai-text-generator',
}
